import { render, staticRenderFns } from "./CardDialog.vue?vue&type=template&id=0c9ca2a8&"
import script from "./CardDialog.vue?vue&type=script&lang=js&"
export * from "./CardDialog.vue?vue&type=script&lang=js&"
import style0 from "./CardDialog.vue?vue&type=style&index=0&id=0c9ca2a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports